import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { 
    myAxios, MyFormData
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export const opts = [
    "Incident Report", 
    "Equipment Damage Report", 
    "Rental Form", 
    "Return Form", 
    "Good Catch Form", 
    "Near Miss Form", 
    "Calibration Verification Form",
    "Safety Inspection", 
    // "Weekly Maintenance Zerk Fittings",
    "Audit Form"
];
//--------------------------------------------------------------------------------------------
export default function AddForm({
    setUserList, 
    closeIt
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    return(
    <Modal
        width = {600}
        maxWidth = "100%"
        closeIt = {closeIt}
        title = "Forms"
        actionKey = "Add"
        handleFormSubmit = {async e => {
            e.preventDefault();
            const formData = new MyFormData(e.currentTarget);
            formData.append("action", "Create");
            //-------------------------------------
            setShowLoader(true);
            const res = await myAxios("forms/checklist.php", formData);
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------
            const newItem = res.data;
            setUserList(userList => [...userList, newItem]);
            closeIt();
        }}
    >
        <div className = "m-3">
            <select
                className = "form-control"
                name = "formType"
                required
            >
                <option value = "">Select</option>
                {opts.filter(opt => user.email === "abaggett@besstestlab.com"?true:opt !== "Audit Form").map((opt, optIndex) => <option key = {optIndex} value = {opt}>{opt}</option>)}
            </select>
        </div>
    </Modal>
    )
}